import { css } from 'linaria';
import { strictBreakpoints } from 'media';

export const benefitItemStyles = css`
	background-color: var(--background-secondary);
	border-radius: 8px;
	cursor: pointer;
`;
export const benefitItemWrapperStyles = css`
	height: 100%;
	background-repeat: no-repeat;
	background-position: bottom right;
`;
export const titleStyles = css`
	padding-right: 16px !important;
	margin-bottom: 8px !important;
`;
export const benefitItemTextContainerStyles = css`
	padding: 24px;
	${strictBreakpoints.onlyDesktop} {
		max-width: 266px;
	}
	${strictBreakpoints.onlyTablet} {
		padding-right: 156px;
	}
	${strictBreakpoints.onlyMobile} {
		padding: 16px;
		padding-right: 136px;
	}
`;
export const BenefitItemTitleStyles = css`
	margin-bottom: 8px;
`;
